import { createFileRoute, redirect } from '@tanstack/react-router';

import { BackgroundJobsPage } from '@/components/features/background-jobs/BackgroundJobsPage';
import { ErrorBoundary, ErrorFallback } from '@/modus/ErrorBoundary';
import { userHasRole } from '@/utils/roles';

export const Route = createFileRoute('/_protected/jobs')({
  beforeLoad: ({ context }) => {
    if (!userHasRole(context.user, 'admin')) {
      throw redirect({ to: '/', replace: true });
    }
  },
  component: BackgroundJobsRoute,
});

function BackgroundJobsRoute() {
  return (
    <ErrorBoundary fallback={(error) => <ErrorFallback error={error} />}>
      <BackgroundJobsPage />
    </ErrorBoundary>
  );
}
